import React from 'react';
import { PRODUCT_DETAIL_LIST_COL_SIZE_LIST } from '../../constants';
import { translate } from 'react-range/lib/utils';
import Icon from '../Icon';
import clsx from 'clsx';

const ProductCardWithDetailsPlaceholder = () => {
  return (
    <div className="skeleton hidden w-full flex-col border-x border-b border-gray-200 lg:flex">
      <div className="flex w-full gap-4 p-3">
        <div
          className="flex h-full self-center"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[0]}%` }}
        >
          <div className="aspect-[3/4] h-full w-full bg-gray-100">
            &nbsp;
          </div>
        </div>
        <div
          className="flex h-full flex-col self-center"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[1]}%` }}
        >
          <span className="mb-1 bg-gray-100 text-md xl:text-lg">
            &nbsp;
          </span>
          <h5 className="mb-0.5 bg-gray-100">&nbsp;</h5>
          <div className="flex items-center gap-0.5 self-start bg-gray-100 py-0.5">
            <span className=" flex-1 text-md">&nbsp;</span>
          </div>
        </div>
        <div
          className="flex h-full self-center bg-gray-100 text-md xl:text-lg"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[2]}%` }}
        >
          &nbsp;
        </div>
        <div
          className="flex h-full self-center text-md xl:text-lg"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[3]}%` }}
        >
          <span className="bg-gray-100">&nbsp;</span>
        </div>
        <div
          className="flex h-full self-center bg-gray-100 text-md xl:text-lg"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[4]}%` }}
        >
          &nbsp;
        </div>
        <div
          className="flex h-full justify-end self-center bg-gray-100"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[5]}%` }}
        >
          &nbsp;
        </div>
        <div
          className="flex h-10 justify-end self-center bg-gray-100"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[6]}%` }}
        >
          &nbsp;
        </div>
        <div
          className="flex h-10 justify-end self-center bg-gray-100"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[7]}%` }}
        >
          &nbsp;
        </div>
        <div
          className="flex h-10 justify-end self-center bg-gray-100"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[8]}%` }}
        >
          &nbsp;
        </div>
        <div
          className="flex h-10 justify-end self-center bg-gray-100"
          style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[9]}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProductCardWithDetailsPlaceholder;
